import type { ConfigMap } from "./custom-app-config-schema";

export const customConstants: ConfigMap = {
	thiemeneetpg: {
		tenant: {
			id: "933f7f49-7018-4a6a-b40c-ca5af345e792",
			name: "Thieme",
		},
		supportEmail: "support@thieme.mail.memorang.com",
		companyName: "Thieme",
		app: {
			id: "1d116d8e-33d4-4fcd-a940-67b54ff82378",
			name: "PRAXIS PROETHICA",
			font: "opensans",
			analytics: {
				mixpanel: {
					id: "292790c46be7f83c4f6a10c2f106bffb",
				},
			},
			logo: {
				stacked: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
				default: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
				company: {
					light: {
						uri: "https://memorang-prod-media.s3.amazonaws.com/app-logos/thiemeneetpg/company_logo_light.png",
					},
					dark: {
						uri: "https://memorang-prod-media.s3.amazonaws.com/app-logos/thiemeneetpg/company_logo_dark.png",
					},
				},
			},
			links: {
				baseUrl: "",
				privacy: "https://memorang.com/legal/privacy",
				tos: "https://memorang.com/legal/terms",
			},
			keys: {
				revenueCat: {
					ios: "",
					android: "",
				},
				oneSignalAppId: "140e7377-0f9a-4dbc-8504-31f484f14565",
			},
			aiAssistant: {
				title: "Health Mentor",
				alias: "Health Mentor",
				icon: "https://yzshdoomwjkaqrvelrki.supabase.co/storage/v1/object/public/memorang-assets/partners/acme/healthcare.png?t=2024-11-15T05%3A16%3A47.701Z",
				showOriginalQuestion: false,
				initialMessage:
					"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
				initialAiMessage: {
					"en-US":
						"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
					"ja-JP":
						"👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
					"zh-CN":
						"👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**",
				},
			},
			isImageChallengeApp: false,
			showCountrySelection: false,
		},
		groupByCategory: true,
		exam: {
			enabled: true,
		},
		store: {
			enabled: false,
		},
		homeView: null,
		showStudyPackAsHome: true,
		reportView: null,
		onboarding: null,
		navigation: {
			routes: {
				main: [
					{
						title: "Home",
						name: "home",
						icon: {
							default: "home-outline",
							selected: "home",
						},
						enabled: true,
					},
					{
						title: "Study Guides",
						name: "study-guides",
						icon: {
							default: "note-multiple-outline",
							selected: "note-multiple",
						},
						enabled: true,
					},
					{
						title: "Progress",
						name: "progress",
						icon: {
							default: "chart-timeline-variant-shimmer",
							selected: "chart-line-variant",
						},
						enabled: true,
					},
					{
						title: "Leaders",
						name: "leaderboard",
						icon: {
							default: "trophy-outline",
							selected: "trophy",
						},
						enabled: true,
					},
					{
						title: "Profile",
						name: "profile",
						icon: {
							default: "account-outline",
							selected: "account",
						},
						enabled: true,
					},
					{
						title: "Store",
						name: "store",
						icon: {
							default: "cart-outline",
							selected: "cart",
						},
						enabled: false,
					},
				],
			},
		},
		sessionView: null,
		theme: {
			colors: {
				light: {
					primary: "rgb(0, 102, 132)",
					onPrimary: "rgb(255, 255, 255)",
					primaryContainer: "rgb(190, 233, 255)",
					onPrimaryContainer: "rgb(0, 31, 42)",
					secondary: "rgb(0, 104, 116)",
					onSecondary: "rgb(255, 255, 255)",
					secondaryContainer: "rgb(131, 220, 235)",
					onSecondaryContainer: "rgb(0, 31, 36)",
					tertiary: "rgb(93, 91, 125)",
					onTertiary: "rgb(255, 255, 255)",
					tertiaryContainer: "rgb(227, 223, 255)",
					onTertiaryContainer: "rgb(26, 24, 54)",
					error: "rgb(186, 26, 26)",
					onError: "rgb(255, 255, 255)",
					errorContainer: "rgb(255, 218, 214)",
					onErrorContainer: "rgb(65, 0, 2)",
					background: "rgb(251, 252, 254)",
					onBackground: "rgb(25, 28, 30)",
					surface: "rgb(251, 252, 254)",
					onSurface: "rgb(25, 28, 30)",
					surfaceVariant: "rgb(220, 228, 233)",
					onSurfaceVariant: "rgb(64, 72, 76)",
					outline: "rgb(112, 120, 125)",
					outlineVariant: "rgb(192, 200, 205)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(46, 49, 50)",
					inverseOnSurface: "rgb(239, 241, 243)",
					inversePrimary: "rgb(104, 211, 255)",
					elevation: {
						level0: "transparent",
						level1: "rgb(238, 245, 248)",
						level2: "rgb(231, 240, 244)",
						level3: "rgb(223, 236, 241)",
						level4: "rgb(221, 234, 239)",
						level5: "rgb(216, 231, 237)",
					},
					surfaceDisabled: "rgba(25, 28, 30, 0.12)",
					onSurfaceDisabled: "rgba(25, 28, 30, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
				dark: {
					primary: "rgb(104, 211, 255)",
					onPrimary: "rgb(0, 53, 70)",
					primaryContainer: "rgb(0, 77, 100)",
					onPrimaryContainer: "rgb(190, 233, 255)",
					secondary: "rgb(79, 216, 235)",
					onSecondary: "rgb(0, 54, 61)",
					secondaryContainer: "rgb(0, 79, 88)",
					onSecondaryContainer: "rgb(151, 240, 255)",
					tertiary: "rgb(198, 194, 234)",
					onTertiary: "rgb(47, 45, 77)",
					tertiaryContainer: "rgb(69, 67, 100)",
					onTertiaryContainer: "rgb(227, 223, 255)",
					error: "rgb(255, 180, 171)",
					onError: "rgb(105, 0, 5)",
					errorContainer: "rgb(147, 0, 10)",
					onErrorContainer: "rgb(255, 180, 171)",
					background: "rgb(25, 28, 30)",
					onBackground: "rgb(225, 226, 228)",
					surface: "rgb(25, 28, 30)",
					onSurface: "rgb(225, 226, 228)",
					surfaceVariant: "rgb(64, 72, 76)",
					onSurfaceVariant: "rgb(192, 200, 205)",
					outline: "rgb(138, 146, 151)",
					outlineVariant: "rgb(64, 72, 76)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(225, 226, 228)",
					inverseOnSurface: "rgb(46, 49, 50)",
					inversePrimary: "rgb(0, 102, 132)",
					elevation: {
						level0: "transparent",
						level1: "rgb(29, 37, 41)",
						level2: "rgb(31, 43, 48)",
						level3: "rgb(34, 48, 55)",
						level4: "rgb(35, 50, 57)",
						level5: "rgb(36, 54, 62)",
					},
					surfaceDisabled: "rgba(225, 226, 228, 0.12)",
					onSurfaceDisabled: "rgba(225, 226, 228, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
			},
			roundness: 2,
		},
	},
	toefl: {
		tenant: {
			id: "5c5a1f03-3dd8-4db4-9a72-77a1686971d9",
			name: "TOEFL",
		},
		supportEmail: "TOEFL@ets.org",
		companyName: "ETS",
		app: {
			id: "5ac37912-3205-430a-b88c-0660ddb449c8",
			name: "PRAXIS PROETHICA",
			trademark: "TOEFL iBT",
			font: "opensans",
			purchase: {},
			scoreRanges: [
				{
					rangeArray: [0, 39],
					range: "0-59",
					color: "rgba(212, 84, 84, 1)",
					icon: "emoticon-sad-outline",
				},
				{
					rangeArray: [40, 59],
					range: "60-79",
					color: "rgba(181, 77, 33, 1)",
					icon: "emoticon-neutral-outline",
				},
				{
					rangeArray: [60, 100],
					range: "80-100",
					color: "rgba(82, 167, 141, 1)",
					icon: "emoticon-happy-outline",
				},
			],
			analytics: {
				mixpanel: {
					id: "f2b45ce0886396e02b9daa8aee85b803",
				},
			},
			logo: {
				stacked: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
				default: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
			},
			links: {
				baseUrl: "https://app.toefl.com",
				privacy: "https://www.ets.org/legal/privacy.html",
				tos: "https://www.ets.org/legal/terms.html",
				ios: "https://apps.apple.com/us/app/official-toefl-practice/id6738998541",
				iosLocalised: {
					"en-US":
						"https://apps.apple.com/us/app/official-toefl-practice/id6738998541",
					"ja-JP":
						"https://apps.apple.com/us/app/official-toefl-practice/id6738998541",
					"zh-CN":
						"https://apps.apple.com/us/app/official-toefl-practice/id6738998541",
				},
				android:
					"https://play.google.com/store/apps/details?id=org.ets.toeflpracticeaicoach",
				androidLocalised: {
					"en-US":
						"https://play.google.com/store/apps/details?id=org.ets.toeflpracticeaicoach&hl=en_IN",
					"ja-JP": null,
					"zh-CN": null,
				},
				redeemSupportUrl: "https://www.ets.org/legal/terms.html",
				companyUrl: "https://www.ets.org",
			},
			keys: {
				revenueCat: {
					ios: "appl_hycCrAhlgNukJDRuKuLsljTgeiY",
					android: "goog_ZcyeWszvzTgMceoTRNwASRlBkfh",
				},
				oneSignalAppId: "76841974-61ff-4d8c-a190-b95ce7789e0b",
				clerk: {
					publishableKeyProd: "pk_live_Y2xlcmsuYXBwLnRvZWZsLmNvbSQ",
					publishableKeyDev:
						"pk_test_Zmlyc3QtY29sdC0zNy5jbGVyay5hY2NvdW50cy5kZXYk",
				},
			},
			aiAssistant: {
				title: "Health Mentor",
				alias: "Health Mentor",
				icon: "https://yzshdoomwjkaqrvelrki.supabase.co/storage/v1/object/public/memorang-assets/partners/acme/healthcare.png?t=2024-11-15T05%3A16%3A47.701Z",
				showOriginalQuestion: false,
				initialMessage:
					"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
				initialAiMessage: {
					"en-US":
						"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
					"ja-JP":
						"👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
					"zh-CN":
						"👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**",
				},
			},
			isImageChallengeApp: false,
			landing: {
				title: {
					prefix: "The",
					decoratedText: "official",
					suffix: "AI app for TOEFL practice",
				},
				marketText: {
					prefix: "Start for free",
					suffix: "with a diagnostic",
				},
				valueProps: [
					{
						icon: "book-open-page-variant-outline",
						title: "Official Practice",
						subtitle: "400+ items authored by the official TOEFL team",
					},
					{
						icon: "head-snowflake-outline",
						title: "Personalised AI Coach",
						subtitle: "Real-time, AI-powered grading, feedback, and tutoring",
					},
					{
						icon: "web",
						title: "Study Anywhere",
						subtitle:
							"Study on the web or download the iPhone and Android apps",
					},
				],
				landingGraphics:
					"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/toefl-items//login-graphics.png",
			},
			showCountrySelection: false,
			elevenLabs: {
				modelId: "eleven_flash_v2_5",
				voiceId: "nova",
			},
			appAvailabilityRegions: ["MX", "FR", "DE", "JP", "US"],
		},
		groupByCategory: null,
		exam: {
			enabled: true,
		},
		store: {
			enabled: false,
		},
		homeView: {
			showRecommendedChallenge: false,
			showArticles: false,
			showChallengeOfTheWeek: false,
		},
		showStudyPackAsHome: null,
		reportView: {
			practiceTest: {
				reviewEnabled: false,
			},
		},
		onboarding: [],
		navigation: {
			routes: {
				main: [
					{
						title: "Home",
						name: "home",
						icon: {
							default: "home-outline",
							selected: "home",
						},
						enabled: true,
						custom: false,
					},
					{
						title: "Progress",
						name: "progress",
						icon: {
							default: "chart-timeline-variant-shimmer",
							selected: "chart-line-variant",
						},
						enabled: true,
					},
					{
						title: "Study-Pack",
						name: "study-pack",
						icon: {
							default: "chart-timeline-variant-shimmer",
							selected: "chart-line-variant",
						},
						enabled: false,
					},
					{
						title: "Progress",
						name: "podcasts",
						icon: {
							default: "chart-timeline-variant-shimmer",
							selected: "chart-line-variant",
						},
						enabled: false,
					},
					{
						title: "Leaders",
						name: "leaderboard",
						icon: {
							default: "trophy-outline",
							selected: "trophy",
						},
						enabled: true,
					},
					{
						title: "Profile",
						name: "profile",
						icon: {
							default: "account-outline",
							selected: "account",
						},
						enabled: true,
					},
					{
						title: "Store",
						name: "store",
						icon: {
							default: "cart-outline",
							selected: "cart",
						},
						enabled: false,
					},
					{
						title: "More",
						name: "more",
						icon: {
							default: "menu",
							selected: "microsoft-xbox-controller-menu",
						},
						enabled: false,
					},
					{
						title: "Study Guides",
						name: "study-guides",
						icon: {
							default: "note-multiple",
							selected: "note-multiple-outline",
						},
						enabled: false,
					},
					{
						title: "Library",
						name: "articles",
						icon: {
							default: "book-open-page-variant-outline",
							selected: "book-open-page-variant",
						},
						enabled: false,
					},
					{
						title: "Library",
						name: "(articles)/articles",
						icon: {
							default: "book-open-page-variant-outline",
							selected: "book-open-page-variant",
						},
						enabled: false,
					},
					{
						title: "Challenges",
						name: "library",
						icon: {
							default: "arm-flex-outline",
							selected: "arm-flex",
						},
						enabled: false,
					},
				],
			},
		},
		sessionView: null,
		theme: {
			colors: {
				light: {
					primary: "rgb(0, 102, 132)",
					onPrimary: "rgb(255, 255, 255)",
					primaryContainer: "rgb(190, 233, 255)",
					onPrimaryContainer: "rgb(0, 31, 42)",
					secondary: "rgb(0, 104, 116)",
					onSecondary: "rgb(255, 255, 255)",
					secondaryContainer: "rgb(131, 220, 235)",
					onSecondaryContainer: "rgb(0, 31, 36)",
					tertiary: "rgb(93, 91, 125)",
					onTertiary: "rgb(255, 255, 255)",
					tertiaryContainer: "rgb(227, 223, 255)",
					onTertiaryContainer: "rgb(26, 24, 54)",
					error: "rgb(186, 26, 26)",
					onError: "rgb(255, 255, 255)",
					errorContainer: "rgb(255, 218, 214)",
					onErrorContainer: "rgb(65, 0, 2)",
					background: "rgb(251, 252, 254)",
					onBackground: "rgb(25, 28, 30)",
					surface: "rgb(251, 252, 254)",
					onSurface: "rgb(25, 28, 30)",
					surfaceVariant: "rgb(220, 228, 233)",
					onSurfaceVariant: "rgb(64, 72, 76)",
					outline: "rgb(112, 120, 125)",
					outlineVariant: "rgb(192, 200, 205)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(46, 49, 50)",
					inverseOnSurface: "rgb(239, 241, 243)",
					inversePrimary: "rgb(104, 211, 255)",
					elevation: {
						level0: "transparent",
						level1: "rgb(238, 245, 248)",
						level2: "rgb(231, 240, 244)",
						level3: "rgb(223, 236, 241)",
						level4: "rgb(221, 234, 239)",
						level5: "rgb(216, 231, 237)",
					},
					surfaceDisabled: "rgba(25, 28, 30, 0.12)",
					onSurfaceDisabled: "rgba(25, 28, 30, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
				dark: {
					primary: "rgb(104, 211, 255)",
					onPrimary: "rgb(0, 53, 70)",
					primaryContainer: "rgb(0, 77, 100)",
					onPrimaryContainer: "rgb(190, 233, 255)",
					secondary: "rgb(79, 216, 235)",
					onSecondary: "rgb(0, 54, 61)",
					secondaryContainer: "rgb(0, 79, 88)",
					onSecondaryContainer: "rgb(151, 240, 255)",
					tertiary: "rgb(198, 194, 234)",
					onTertiary: "rgb(47, 45, 77)",
					tertiaryContainer: "rgb(69, 67, 100)",
					onTertiaryContainer: "rgb(227, 223, 255)",
					error: "rgb(255, 180, 171)",
					onError: "rgb(105, 0, 5)",
					errorContainer: "rgb(147, 0, 10)",
					onErrorContainer: "rgb(255, 180, 171)",
					background: "rgb(25, 28, 30)",
					onBackground: "rgb(225, 226, 228)",
					surface: "rgb(25, 28, 30)",
					onSurface: "rgb(225, 226, 228)",
					surfaceVariant: "rgb(64, 72, 76)",
					onSurfaceVariant: "rgb(192, 200, 205)",
					outline: "rgb(138, 146, 151)",
					outlineVariant: "rgb(64, 72, 76)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(225, 226, 228)",
					inverseOnSurface: "rgb(46, 49, 50)",
					inversePrimary: "rgb(0, 102, 132)",
					elevation: {
						level0: "transparent",
						level1: "rgb(29, 37, 41)",
						level2: "rgb(31, 43, 48)",
						level3: "rgb(34, 48, 55)",
						level4: "rgb(35, 50, 57)",
						level5: "rgb(36, 54, 62)",
					},
					surfaceDisabled: "rgba(225, 226, 228, 0.12)",
					onSurfaceDisabled: "rgba(225, 226, 228, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
			},
			roundness: 2,
		},
	},
	therapyed: {
		tenant: {
			id: "53d94851-4af6-4dfc-943d-92929b3e9dcc",
			name: "TherapyEd",
		},
		supportEmail: "info@therapyed.com",
		companyName: "TherapyEd",
		app: {
			id: "db878dfd-9617-456b-b458-14902e06462f",
			name: "PRAXIS PROETHICA",
			trademark: "TherapyEd",
			font: "opensans",
			scoreRanges: [
				{
					rangeArray: [0, 55],
					range: "0-55",
					color: "#d66565",
					icon: "emoticon-sad-outline",
				},
				{
					rangeArray: [56, 69],
					range: "56-69",
					color: "#dda53a",
					icon: "emoticon-neutral-outline",
				},
				{
					rangeArray: [70, 100],
					range: "70-100",
					color: "#66bb68",
					icon: "emoticon-happy-outline",
				},
			],
			fontSizes: {
				stem: 18,
				answer: 18,
			},
			analytics: {
				mixpanel: {
					id: "5b3fe7e0378f1a1bd87bc085ddc9b66e",
				},
			},
			logo: {
				stacked: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
				default: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
				company: {
					light: {
						uri: "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/company_logo_light.png",
					},
					dark: {
						uri: "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/company_logo_dark.png",
					},
				},
			},
			links: {
				baseUrl: "https://app.therapyed.com",
				privacy: "https://memorang.com/legal/privacy",
				tos: "https://memorang.com/legal/terms",
				redeemSupportUrl:
					"https://therapyed.zendesk.com/hc/en-us/articles/6864418376468-How-can-I-redeem-access-to-my-purchased-content-",
				companyUrl: "https://www.therapyed.com/",
			},
			keys: {
				revenueCat: {
					ios: "appl_LCnNlSXwMCLCGLQsftcakAoejTs",
					android: "goog_cFBRaPbCakxtxjBbmsUDprlTzfN",
				},
				oneSignalAppId: "ac799c9b-47da-4692-b722-ce25feffc4ca",
				clerk: {
					publishableKeyProd: "pk_live_Y2xlcmsuYXBwLnRoZXJhcHllZC5jb20k",
					publishableKeyDev:
						"pk_test_ZnJlZS1sZW9wYXJkLTExLmNsZXJrLmFjY291bnRzLmRldiQ",
				},
			},
			supportUrl: "https://therapyed.zendesk.com/hc/en-us",
			aiAssistant: {
				title: "Health Mentor",
				alias: "Health Mentor",
				icon: "https://yzshdoomwjkaqrvelrki.supabase.co/storage/v1/object/public/memorang-assets/partners/acme/healthcare.png?t=2024-11-15T05%3A16%3A47.701Z",
				showOriginalQuestion: false,
				initialMessage:
					"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
				initialAiMessage: {
					"en-US":
						"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
					"ja-JP":
						"👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
					"zh-CN":
						"👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**",
				},
			},
			isImageChallengeApp: false,
			landing: {
				title: {
					prefix: "The",
					decoratedText: "official",
					suffix: "AI app for TherapyEd Test Prep",
				},
				valueProps: [
					{
						icon: "book-open-page-variant-outline",
						title: "Official Practice",
						subtitle: "400+ items authored by the official TherapyEd team",
					},
					{
						icon: "head-snowflake-outline",
						title: "Personalised AI Coach",
						subtitle: "Real-time, AI-powered grading, feedback, and tutoring",
					},
					{
						icon: "web",
						title: "Study Anywhere",
						subtitle:
							"Study on the web or download the iPhone and Android apps",
					},
				],
				landingGraphics:
					"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/therapyed/therapyed/aibl/landing_graphic.png",
			},
			showCountrySelection: false,
			elevenLabs: {
				modelId: "eleven_flash_v2_5",
				voiceId: "nova",
			},
		},
		groupByCategory: null,
		exam: {
			enabled: true,
			quizEnabled: false,
			allowChangeExam: true,
		},
		store: {
			enabled: true,
		},
		homeView: {
			showRecommendedChallenge: false,
			showArticles: false,
			showChallengeOfTheWeek: false,
		},
		showStudyPackAsHome: null,
		reportView: {
			practiceTest: {
				reviewEnabled: true,
			},
		},
		onboarding: [
			{
				step: "privacy",
				enabled: true,
				title: "Your privacy matters",
				isMobile: true,
				data: [
					{
						icon: "shield-check-outline",
					},
					{
						icon: "lock-outline",
					},
					{
						icon: "account-cog-outline",
					},
					{
						icon: "file-document-outline",
					},
				],
			},
			{
				step: "chooseContext",
				enabled: true,
				title: "Choose your Exam",
				description: "onboarding.steps.chooseContext.description",
			},
			{
				step: "examDate",
				enabled: true,
				title: "Choose your Exam Date",
				description: "onboarding.steps.testDate.description",
			},
		],
		navigation: {
			routes: {
				main: [
					{
						title: "Home",
						name: "home",
						icon: {
							default: "home-outline",
							selected: "home",
						},
						enabled: true,
					},
					{
						title: "Podcasts",
						name: "study-pack",
						icon: {
							default: "book-open-page-variant-outline",
							selected: "book-open-page-variant",
						},
						enabled: false,
					},
					{
						title: "Podcasts",
						name: "podcasts",
						icon: {
							default: "book-open-page-variant-outline",
							selected: "book-open-page-variant",
						},
						enabled: false,
					},
					{
						title: "Progress",
						name: "progress",
						icon: {
							default: "chart-timeline-variant-shimmer",
							selected: "chart-line-variant",
						},
						enabled: true,
					},
					{
						title: "Leaders",
						name: "leaderboard",
						icon: {
							default: "trophy-outline",
							selected: "trophy",
						},
						enabled: true,
					},
					{
						title: "Store",
						name: "store",
						icon: {
							default: "cart-outline",
							selected: "cart",
						},
						enabled: true,
					},
					{
						title: "More",
						name: "more",
						icon: {
							default: "menu",
							selected: "microsoft-xbox-controller-menu",
						},
						enabled: true,
					},
					{
						title: "Articles",
						name: "(articles)/articles",
						icon: {
							default: "file-document-multiple-outline",
							selected: "file-document-multiple",
						},
						enabled: false,
					},
					{
						title: "Articles",
						name: "articles",
						icon: {
							default: "file-document-multiple-outline",
							selected: "file-document-multiple",
						},
						enabled: false,
					},
					{
						title: "Challenges",
						name: "challenges",
						icon: {
							default: "arm-flex-outline",
							selected: "arm-flex",
						},
						enabled: false,
					},
					{
						title: "Study Guides",
						name: "study-guides",
						icon: {
							default: "note-multiple",
							selected: "note-multiple-outline",
						},
						enabled: false,
					},
					{
						title: "Challenges",
						name: "library",
						icon: {
							default: "arm-flex-outline",
							selected: "arm-flex",
						},
						enabled: false,
					},
				],
			},
		},
		sessionView: {
			cta: "Study Now",
			maxItems: {
				flashcards: 100,
				questions: 50,
			},
			timer: false,
			showCrossOut: true,
			selectionStrategy: {
				default: "random",
				optimized: true,
				random: true,
				shuffled: true,
			},
		},
		theme: {
			colors: {
				light: {
					primary: "rgb(0, 102, 132)",
					onPrimary: "rgb(255, 255, 255)",
					primaryContainer: "rgb(190, 233, 255)",
					onPrimaryContainer: "rgb(0, 31, 42)",
					secondary: "rgb(0, 104, 116)",
					onSecondary: "rgb(255, 255, 255)",
					secondaryContainer: "rgb(131, 220, 235)",
					onSecondaryContainer: "rgb(0, 31, 36)",
					tertiary: "rgb(93, 91, 125)",
					onTertiary: "rgb(255, 255, 255)",
					tertiaryContainer: "rgb(227, 223, 255)",
					onTertiaryContainer: "rgb(26, 24, 54)",
					error: "rgb(186, 26, 26)",
					onError: "rgb(255, 255, 255)",
					errorContainer: "rgb(255, 218, 214)",
					onErrorContainer: "rgb(65, 0, 2)",
					background: "rgb(251, 252, 254)",
					onBackground: "rgb(25, 28, 30)",
					surface: "rgb(251, 252, 254)",
					onSurface: "rgb(25, 28, 30)",
					surfaceVariant: "rgb(220, 228, 233)",
					onSurfaceVariant: "rgb(64, 72, 76)",
					outline: "rgb(112, 120, 125)",
					outlineVariant: "rgb(192, 200, 205)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(46, 49, 50)",
					inverseOnSurface: "rgb(239, 241, 243)",
					inversePrimary: "rgb(104, 211, 255)",
					elevation: {
						level0: "transparent",
						level1: "rgb(238, 245, 248)",
						level2: "rgb(231, 240, 244)",
						level3: "rgb(223, 236, 241)",
						level4: "rgb(221, 234, 239)",
						level5: "rgb(216, 231, 237)",
					},
					surfaceDisabled: "rgba(25, 28, 30, 0.12)",
					onSurfaceDisabled: "rgba(25, 28, 30, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
				dark: {
					primary: "rgb(104, 211, 255)",
					onPrimary: "rgb(0, 53, 70)",
					primaryContainer: "rgb(0, 77, 100)",
					onPrimaryContainer: "rgb(190, 233, 255)",
					secondary: "rgb(79, 216, 235)",
					onSecondary: "rgb(0, 54, 61)",
					secondaryContainer: "rgb(0, 79, 88)",
					onSecondaryContainer: "rgb(151, 240, 255)",
					tertiary: "rgb(198, 194, 234)",
					onTertiary: "rgb(47, 45, 77)",
					tertiaryContainer: "rgb(69, 67, 100)",
					onTertiaryContainer: "rgb(227, 223, 255)",
					error: "rgb(255, 180, 171)",
					onError: "rgb(105, 0, 5)",
					errorContainer: "rgb(147, 0, 10)",
					onErrorContainer: "rgb(255, 180, 171)",
					background: "rgb(25, 28, 30)",
					onBackground: "rgb(225, 226, 228)",
					surface: "rgb(25, 28, 30)",
					onSurface: "rgb(225, 226, 228)",
					surfaceVariant: "rgb(64, 72, 76)",
					onSurfaceVariant: "rgb(192, 200, 205)",
					outline: "rgb(138, 146, 151)",
					outlineVariant: "rgb(64, 72, 76)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(225, 226, 228)",
					inverseOnSurface: "rgb(46, 49, 50)",
					inversePrimary: "rgb(0, 102, 132)",
					elevation: {
						level0: "transparent",
						level1: "rgb(29, 37, 41)",
						level2: "rgb(31, 43, 48)",
						level3: "rgb(34, 48, 55)",
						level4: "rgb(35, 50, 57)",
						level5: "rgb(36, 54, 62)",
					},
					surfaceDisabled: "rgba(225, 226, 228, 0.12)",
					onSurfaceDisabled: "rgba(225, 226, 228, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
			},
			roundness: 2,
		},
	},
	jbjs: {
		tenant: {
			id: "31da93b9-653e-44e9-94ff-b67a7ffd7012",
			name: "JBJS",
		},
		supportEmail: "support@mail.jbjs.org",
		companyName: "JBJS",
		app: {
			id: "864cbe1b-be3e-43a5-a079-d7220aaf61a0",
			name: "PRAXIS PROETHICA",
			font: "opensans",
			purchase: {
				isSubscriptionEnabled: true,
			},
			scoreRanges: [
				{
					rangeArray: [0, 74],
					range: "0-74",
					color: "#d66565",
					icon: "emoticon-sad-outline",
				},
				{
					rangeArray: [75, 84],
					range: "75-84",
					color: "#dda53a",
					icon: "emoticon-neutral-outline",
				},
				{
					rangeArray: [85, 100],
					range: "85-100",
					color: "#66bb68",
					icon: "emoticon-happy-outline",
				},
			],
			analytics: {
				mixpanel: {
					id: "c4ccfdfa4bb14a8794546e96a01c1178",
				},
			},
			logo: {
				stacked: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
				default: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
			},
			links: {
				baseUrl: "https://app.jbjs.org",
				privacy: "https://memorang.com/legal/privacy",
				tos: "https://memorang.com/legal/terms",
				redeemSupportUrl: "https://app.jbjs.org/legal/terms",
			},
			keys: {
				revenueCat: {
					ios: "",
					android: "",
				},
				oneSignalAppId: "",
				clerk: {
					publishableKeyProd: "pk_live_Y2xlcmsuYXBwLmpianMub3JnJA",
					publishableKeyDev:
						"pk_test_c2ltcGxlLW1vbmFyY2gtMTIuY2xlcmsuYWNjb3VudHMuZGV2JA",
				},
			},
			supportUrl: "https://jbjs.org/terms",
			aiAssistant: {
				title: "Health Mentor",
				alias: "Health Mentor",
				icon: "https://yzshdoomwjkaqrvelrki.supabase.co/storage/v1/object/public/memorang-assets/partners/acme/healthcare.png?t=2024-11-15T05%3A16%3A47.701Z",
				showOriginalQuestion: false,
				initialMessage:
					"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
				initialAiMessage: {
					"en-US":
						"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
					"ja-JP":
						"👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
					"zh-CN":
						"👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**",
				},
			},
			isImageChallengeApp: false,
			landing: {
				title: {
					prefix: "The",
					decoratedText: "official",
					suffix: "AI app for JBJS ACE",
				},
				valueProps: [
					{
						icon: "book-open-page-variant-outline",
						title: "Official Practice",
						subtitle: "400+ items authored by the official JBJS team",
					},
					{
						icon: "head-snowflake-outline",
						title: "Personalised AI Coach",
						subtitle: "Real-time, AI-powered grading, feedback, and tutoring",
					},
					{
						icon: "web",
						title: "Study Anywhere",
						subtitle:
							"Study on the web or download the iPhone and Android apps",
					},
				],
				landingGraphics:
					"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/demo/acme/ACME%20Mockup_light.webp",
			},
			showCountrySelection: false,
			elevenLabs: {
				modelId: "eleven_flash_v2_5",
				voiceId: "nova",
			},
		},
		groupByCategory: null,
		exam: {
			enabled: false,
			quizEnabled: false,
			allowChangeExam: false,
		},
		store: {
			enabled: false,
		},
		homeView: {
			showRecommendedChallenge: false,
			showArticles: false,
			showChallengeOfTheWeek: false,
		},
		showStudyPackAsHome: null,
		reportView: {
			practiceTest: {
				reviewEnabled: true,
			},
		},
		onboarding: [],
		navigation: {
			routes: {
				main: [
					{
						title: "Home",
						name: "home",
						icon: {
							default: "home-outline",
							selected: "home",
						},
						enabled: true,
					},
					{
						title: "Study-Pack",
						name: "study-pack",
						icon: {
							default: "study-pack-outline",
							selected: "study-pack",
						},
						enabled: false,
						custom: true,
					},
					{
						title: "Challenges",
						name: "challenges",
						icon: {
							default: "arm-flex-outline",
							selected: "arm-flex",
						},
						enabled: false,
					},
					{
						title: "Library",
						name: "(articles)/articles",
						icon: {
							default: "book-open-page-variant-outline",
							selected: "book-open-page-variant",
						},
						enabled: false,
					},
					{
						title: "Challenges",
						name: "library",
						icon: {
							default: "arm-flex-outline",
							selected: "arm-flex",
						},
						enabled: false,
					},
					{
						title: "Store",
						name: "store",
						icon: {
							default: "cart-outline",
							selected: "cart",
						},
						enabled: false,
					},
					{
						title: "Study Guides",
						name: "study-guides",
						icon: {
							default: "note-multiple-outline",
							selected: "note-multiple",
						},
						enabled: false,
					},
					{
						title: "CME",
						name: "cme",
						icon: {
							default: "school-outline",
							selected: "school",
						},
						enabled: false,
					},
					{
						title: "Videos",
						name: "videos",
						icon: {
							default: "video-outline",
							selected: "video",
						},
						enabled: false,
					},
					{
						title: "Podcasts",
						name: "podcasts",
						icon: {
							default: "google-podcast",
							selected: "google-podcast",
						},
						enabled: true,
					},
					{
						title: "Progress",
						name: "progress",
						icon: {
							default: "lightbulb-on-outline",
							selected: "lightbulb-on",
						},
						enabled: true,
					},
					{
						title: "Leaders",
						name: "leaderboard",
						icon: {
							default: "podium-gold",
							selected: "podium",
						},
						enabled: true,
					},
					{
						title: "Profile",
						name: "profile",
						icon: {
							default: "account-outline",
							selected: "account",
						},
						enabled: false,
					},
					{
						title: "More",
						name: "more",
						icon: {
							default: "menu",
							selected: "microsoft-xbox-controller-menu",
						},
						enabled: false,
					},
				],
			},
		},
		sessionView: {
			postAnswerStats: {
				showXpEarned: false,
				showNumAttempts: false,
			},
			showCrossOut: false,
		},
		theme: {
			colors: {
				light: {
					primary: "rgb(0, 102, 132)",
					onPrimary: "rgb(255, 255, 255)",
					primaryContainer: "rgb(190, 233, 255)",
					onPrimaryContainer: "rgb(0, 31, 42)",
					secondary: "rgb(0, 104, 116)",
					onSecondary: "rgb(255, 255, 255)",
					secondaryContainer: "rgb(131, 220, 235)",
					onSecondaryContainer: "rgb(0, 31, 36)",
					tertiary: "rgb(93, 91, 125)",
					onTertiary: "rgb(255, 255, 255)",
					tertiaryContainer: "rgb(227, 223, 255)",
					onTertiaryContainer: "rgb(26, 24, 54)",
					error: "rgb(186, 26, 26)",
					onError: "rgb(255, 255, 255)",
					errorContainer: "rgb(255, 218, 214)",
					onErrorContainer: "rgb(65, 0, 2)",
					background: "rgb(251, 252, 254)",
					onBackground: "rgb(25, 28, 30)",
					surface: "rgb(251, 252, 254)",
					onSurface: "rgb(25, 28, 30)",
					surfaceVariant: "rgb(220, 228, 233)",
					onSurfaceVariant: "rgb(64, 72, 76)",
					outline: "rgb(112, 120, 125)",
					outlineVariant: "rgb(192, 200, 205)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(46, 49, 50)",
					inverseOnSurface: "rgb(239, 241, 243)",
					inversePrimary: "rgb(104, 211, 255)",
					elevation: {
						level0: "transparent",
						level1: "rgb(238, 245, 248)",
						level2: "rgb(231, 240, 244)",
						level3: "rgb(223, 236, 241)",
						level4: "rgb(221, 234, 239)",
						level5: "rgb(216, 231, 237)",
					},
					surfaceDisabled: "rgba(25, 28, 30, 0.12)",
					onSurfaceDisabled: "rgba(25, 28, 30, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
				dark: {
					primary: "rgb(104, 211, 255)",
					onPrimary: "rgb(0, 53, 70)",
					primaryContainer: "rgb(0, 77, 100)",
					onPrimaryContainer: "rgb(190, 233, 255)",
					secondary: "rgb(79, 216, 235)",
					onSecondary: "rgb(0, 54, 61)",
					secondaryContainer: "rgb(0, 79, 88)",
					onSecondaryContainer: "rgb(151, 240, 255)",
					tertiary: "rgb(198, 194, 234)",
					onTertiary: "rgb(47, 45, 77)",
					tertiaryContainer: "rgb(69, 67, 100)",
					onTertiaryContainer: "rgb(227, 223, 255)",
					error: "rgb(255, 180, 171)",
					onError: "rgb(105, 0, 5)",
					errorContainer: "rgb(147, 0, 10)",
					onErrorContainer: "rgb(255, 180, 171)",
					background: "rgb(25, 28, 30)",
					onBackground: "rgb(225, 226, 228)",
					surface: "rgb(25, 28, 30)",
					onSurface: "rgb(225, 226, 228)",
					surfaceVariant: "rgb(64, 72, 76)",
					onSurfaceVariant: "rgb(192, 200, 205)",
					outline: "rgb(138, 146, 151)",
					outlineVariant: "rgb(64, 72, 76)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(225, 226, 228)",
					inverseOnSurface: "rgb(46, 49, 50)",
					inversePrimary: "rgb(0, 102, 132)",
					elevation: {
						level0: "transparent",
						level1: "rgb(29, 37, 41)",
						level2: "rgb(31, 43, 48)",
						level3: "rgb(34, 48, 55)",
						level4: "rgb(35, 50, 57)",
						level5: "rgb(36, 54, 62)",
					},
					surfaceDisabled: "rgba(225, 226, 228, 0.12)",
					onSurfaceDisabled: "rgba(225, 226, 228, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
			},
			roundness: 2,
		},
	},
	hiset: {
		tenant: {
			id: "ab10130c-2a45-4f14-8c14-aae29b744640",
			name: "HiSet",
		},
		supportEmail: "ptsupport@psionline.com",
		companyName: "PSI",
		app: {
			id: "2c183c41-6dc0-4ef4-837c-0eb0f86a61b2",
			name: "PRAXIS PROETHICA",
			font: "opensans",
			scoreRanges: [
				{
					rangeArray: [0, 74],
					range: "0-74",
					color: "#d66565",
					icon: "emoticon-sad-outline",
				},
				{
					rangeArray: [75, 84],
					range: "75-84",
					color: "#dda53a",
					icon: "emoticon-neutral-outline",
				},
				{
					rangeArray: [85, 100],
					range: "85-100",
					color: "#66bb68",
					icon: "emoticon-happy-outline",
				},
			],
			fontSizes: {
				stem: 16,
				answer: 16,
			},
			analytics: {
				mixpanel: {
					id: "fa9c619bbdd5631c565a957a1bc0b1b5",
				},
			},
			logo: {
				stacked: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
				default: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
				company: {
					light: {
						uri: "https://memorang-prod-media.s3.amazonaws.com/app-logos/psi/company_logo_light.png",
					},
					dark: {
						uri: "https://memorang-prod-media.s3.amazonaws.com/app-logos/psi/company_logo_dark.png",
					},
				},
			},
			links: {
				baseUrl: "https://app.psiexams.com",
				privacy: "https://memorang.com/legal/privacy",
				tos: "https://memorang.com/legal/terms",
				ios: "https://apps.apple.com/in/app/psi-test-prep/id1565909858",
				android:
					"https://play.google.com/store/apps/details?id=com.memorang.psi.insurance.testprep&hl=en&gl=US",
				redeemSupportUrl: "https://app.psiexams.com/legal/privacy",
				companyUrl: "https://www.psiexams.com/en-gb/",
			},
			keys: {
				revenueCat: {
					ios: "",
					android: "",
				},
				oneSignalAppId: "",
			},
			aiAssistant: {
				title: "Health Mentor",
				alias: "Health Mentor",
				icon: "https://yzshdoomwjkaqrvelrki.supabase.co/storage/v1/object/public/memorang-assets/partners/acme/healthcare.png?t=2024-11-15T05%3A16%3A47.701Z",
				showOriginalQuestion: false,
				initialMessage:
					"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
				initialAiMessage: {
					"en-US":
						"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
					"ja-JP":
						"👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
					"zh-CN":
						"👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**",
				},
			},
			isImageChallengeApp: false,
			showCountrySelection: false,
		},
		groupByCategory: true,
		exam: {
			enabled: true,
			quizEnabled: true,
			allowChangeExam: true,
		},
		store: {
			enabled: false,
		},
		homeView: null,
		showStudyPackAsHome: null,
		reportView: null,
		onboarding: [
			{
				step: "chooseContext",
				enabled: true,
				title: "Choose your Exam",
			},
		],
		navigation: {
			routes: {
				main: [
					{
						title: "Home",
						name: "home",
						icon: {
							default: "home-outline",
							selected: "home",
						},
						enabled: true,
						custom: false,
					},
					{
						title: "Study Guides",
						name: "study-guides",
						icon: {
							default: "note-multiple",
							selected: "note-multiple-outline",
						},
						enabled: false,
					},
					{
						title: "Progress",
						name: "progress",
						icon: {
							default: "chart-timeline-variant-shimmer",
							selected: "chart-line-variant",
						},
						enabled: true,
					},
					{
						title: "Leaders",
						name: "leaderboard",
						icon: {
							default: "trophy-outline",
							selected: "trophy",
						},
						enabled: true,
					},
					{
						title: "Store",
						name: "store",
						icon: {
							default: "cart-outline",
							selected: "cart",
						},
						enabled: false,
					},
					{
						title: "Articles",
						name: "articles",
						icon: {
							default: "file-document-multiple-outline",
							selected: "file-document-multiple",
						},
						enabled: false,
					},
					{
						title: "Challenges",
						name: "challenges",
						icon: {
							default: "arm-flex-outline",
							selected: "arm-flex",
						},
						enabled: false,
					},
					{
						title: "More",
						name: "more",
						icon: {
							default: "menu",
							selected: "microsoft-xbox-controller-menu",
						},
						enabled: true,
					},
				],
			},
		},
		sessionView: null,
		theme: {
			colors: {
				light: {
					primary: "rgb(0, 102, 132)",
					onPrimary: "rgb(255, 255, 255)",
					primaryContainer: "rgb(190, 233, 255)",
					onPrimaryContainer: "rgb(0, 31, 42)",
					secondary: "rgb(0, 104, 116)",
					onSecondary: "rgb(255, 255, 255)",
					secondaryContainer: "rgb(131, 220, 235)",
					onSecondaryContainer: "rgb(0, 31, 36)",
					tertiary: "rgb(93, 91, 125)",
					onTertiary: "rgb(255, 255, 255)",
					tertiaryContainer: "rgb(227, 223, 255)",
					onTertiaryContainer: "rgb(26, 24, 54)",
					error: "rgb(186, 26, 26)",
					onError: "rgb(255, 255, 255)",
					errorContainer: "rgb(255, 218, 214)",
					onErrorContainer: "rgb(65, 0, 2)",
					background: "rgb(251, 252, 254)",
					onBackground: "rgb(25, 28, 30)",
					surface: "rgb(251, 252, 254)",
					onSurface: "rgb(25, 28, 30)",
					surfaceVariant: "rgb(220, 228, 233)",
					onSurfaceVariant: "rgb(64, 72, 76)",
					outline: "rgb(112, 120, 125)",
					outlineVariant: "rgb(192, 200, 205)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(46, 49, 50)",
					inverseOnSurface: "rgb(239, 241, 243)",
					inversePrimary: "rgb(104, 211, 255)",
					elevation: {
						level0: "transparent",
						level1: "rgb(238, 245, 248)",
						level2: "rgb(231, 240, 244)",
						level3: "rgb(223, 236, 241)",
						level4: "rgb(221, 234, 239)",
						level5: "rgb(216, 231, 237)",
					},
					surfaceDisabled: "rgba(25, 28, 30, 0.12)",
					onSurfaceDisabled: "rgba(25, 28, 30, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
				dark: {
					primary: "rgb(104, 211, 255)",
					onPrimary: "rgb(0, 53, 70)",
					primaryContainer: "rgb(0, 77, 100)",
					onPrimaryContainer: "rgb(190, 233, 255)",
					secondary: "rgb(79, 216, 235)",
					onSecondary: "rgb(0, 54, 61)",
					secondaryContainer: "rgb(0, 79, 88)",
					onSecondaryContainer: "rgb(151, 240, 255)",
					tertiary: "rgb(198, 194, 234)",
					onTertiary: "rgb(47, 45, 77)",
					tertiaryContainer: "rgb(69, 67, 100)",
					onTertiaryContainer: "rgb(227, 223, 255)",
					error: "rgb(255, 180, 171)",
					onError: "rgb(105, 0, 5)",
					errorContainer: "rgb(147, 0, 10)",
					onErrorContainer: "rgb(255, 180, 171)",
					background: "rgb(25, 28, 30)",
					onBackground: "rgb(225, 226, 228)",
					surface: "rgb(25, 28, 30)",
					onSurface: "rgb(225, 226, 228)",
					surfaceVariant: "rgb(64, 72, 76)",
					onSurfaceVariant: "rgb(192, 200, 205)",
					outline: "rgb(138, 146, 151)",
					outlineVariant: "rgb(64, 72, 76)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(225, 226, 228)",
					inverseOnSurface: "rgb(46, 49, 50)",
					inversePrimary: "rgb(0, 102, 132)",
					elevation: {
						level0: "transparent",
						level1: "rgb(29, 37, 41)",
						level2: "rgb(31, 43, 48)",
						level3: "rgb(34, 48, 55)",
						level4: "rgb(35, 50, 57)",
						level5: "rgb(36, 54, 62)",
					},
					surfaceDisabled: "rgba(225, 226, 228, 0.12)",
					onSurfaceDisabled: "rgba(225, 226, 228, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
			},
			roundness: 2,
		},
	},
	psi: {
		tenant: {
			id: "dcfc373c-0870-4a88-88c3-4a706de51463",
			name: "PSI",
		},
		supportEmail: "ptsupport@psionline.com",
		companyName: "PSI",
		app: {
			id: "2c183c41-6dc0-4ef4-837c-0eb0f86a61b1",
			name: "PRAXIS PROETHICA",
			trademark: "PSI",
			font: "opensans",
			scoreRanges: [
				{
					rangeArray: [0, 74],
					range: "0-74",
					color: "#d66565",
					icon: "emoticon-sad-outline",
				},
				{
					rangeArray: [75, 84],
					range: "75-84",
					color: "#dda53a",
					icon: "emoticon-neutral-outline",
				},
				{
					rangeArray: [85, 100],
					range: "85-100",
					color: "#66bb68",
					icon: "emoticon-happy-outline",
				},
			],
			fontSizes: {
				stem: 16,
				answer: 16,
			},
			analytics: {
				mixpanel: {
					id: "e2354d451161a9deacf641952f49ab00",
				},
			},
			logo: {
				stacked: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
				default: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
				company: {
					light: {
						uri: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_light.png?t=2024-09-11T02%3A53%3A01.928Z",
					},
					dark: {
						uri: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_dark.png?t=2024-09-11T02%3A52%3A51.342Z",
					},
				},
			},
			links: {
				baseUrl: "https://app.psiexams.com",
				privacy: "https://memorang.com/legal/privacy",
				tos: "https://memorang.com/legal/terms",
				ios: "https://apps.apple.com/in/app/psi-test-prep/id1565909858",
				android:
					"https://play.google.com/store/apps/details?id=com.memorang.psi.insurance.testprep&hl=en&gl=US",
				redeemSupportUrl: "https://app.psiexams.com/legal/privacy",
				companyUrl: "https://www.psiexams.com/en-gb/",
			},
			keys: {
				revenueCat: {
					ios: "appl_tfbBxQbsoZLVyISjLSZWoccqCzi",
					android: "goog_xnLVKZpZmlknMbzVJXNOLTdigye",
				},
				oneSignalAppId: "67d6088f-0bcd-4d04-9984-b5f8efa0dcfc",
				clerk: {
					publishableKeyProd: "pk_live_Y2xlcmsuYXBwLnBzaWV4YW1zLmNvbSQ",
					publishableKeyDev:
						"pk_test_Z2FtZS1saW9uZXNzLTgyLmNsZXJrLmFjY291bnRzLmRldiQ",
				},
			},
			aiAssistant: {
				title: "Health Mentor",
				alias: "Health Mentor",
				icon: "https://yzshdoomwjkaqrvelrki.supabase.co/storage/v1/object/public/memorang-assets/partners/acme/healthcare.png?t=2024-11-15T05%3A16%3A47.701Z",
				showOriginalQuestion: false,
				initialMessage:
					"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
				initialAiMessage: {
					"en-US":
						"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
					"ja-JP":
						"👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
					"zh-CN":
						"👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**",
				},
			},
			isImageChallengeApp: false,
			landing: {
				title: {
					prefix: "The",
					decoratedText: "official",
					suffix: "AI app for PSI Test Prep",
				},
				marketText: {
					prefix: "Start for free",
					suffix: "with a diagnostic",
				},
				valueProps: [
					{
						icon: "book-open-page-variant-outline",
						title: "Official Practice",
						subtitle: "400+ items authored by the official PSI team",
					},
					{
						icon: "head-snowflake-outline",
						title: "Personalised AI Coach",
						subtitle: "Real-time, AI-powered grading, feedback, and tutoring",
					},
					{
						icon: "web",
						title: "Study Anywhere",
						subtitle:
							"Study on the web or download the iPhone and Android apps",
					},
				],
				landingGraphics:
					"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/icons/landing_graphics.png",
			},
			showCountrySelection: false,
		},
		groupByCategory: null,
		exam: {
			enabled: true,
			quizEnabled: true,
			allowChangeExam: true,
		},
		store: {
			enabled: true,
		},
		homeView: {
			showRecommendedChallenge: false,
			showArticles: false,
			showChallengeOfTheWeek: false,
		},
		showStudyPackAsHome: null,
		reportView: {
			practiceTest: {
				reviewEnabled: true,
			},
		},
		onboarding: [
			{
				step: "privacy",
				enabled: true,
				title: "Your privacy matters",
				isMobile: true,
				data: [
					{
						icon: "shield-check-outline",
					},
					{
						icon: "lock-outline",
					},
					{
						icon: "account-cog-outline",
					},
					{
						icon: "file-document-outline",
					},
				],
			},
			{
				step: "chooseCategory",
				enabled: true,
				title: "Choose Category",
				description: "onboarding.steps.chooseCategory.description",
			},
			{
				step: "chooseLevel",
				enabled: true,
				title: "Choose Level",
			},
			{
				step: "chooseState",
				enabled: true,
				title: "Choose State",
			},
			{
				step: "chooseContext",
				enabled: true,
				title: "Choose your Exam",
				description: "onboarding.steps.chooseContext.description",
			},
			{
				step: "examDate",
				enabled: true,
				title: "Choose your exam date",
				description: "onboarding.steps.testDate.description",
			},
		],
		navigation: {
			routes: {
				main: [
					{
						title: "Home",
						name: "home",
						icon: {
							default: "home-outline",
							selected: "home",
						},
						enabled: true,
						custom: false,
					},
					{
						title: "Podcasts",
						name: "podcasts",
						icon: {
							default: "book-open-page-variant-outline",
							selected: "book-open-page-variant",
						},
						enabled: false,
					},
					{
						title: "Podcasts",
						name: "study-pack",
						icon: {
							default: "book-open-page-variant-outline",
							selected: "book-open-page-variant",
						},
						enabled: false,
					},
					{
						title: "Study Guides",
						name: "study-guides",
						icon: {
							default: "note-multiple",
							selected: "note-multiple-outline",
						},
						enabled: false,
					},
					{
						title: "Progress",
						name: "progress",
						icon: {
							default: "chart-timeline-variant-shimmer",
							selected: "chart-line-variant",
						},
						enabled: true,
					},
					{
						title: "Leaders",
						name: "leaderboard",
						icon: {
							default: "trophy-outline",
							selected: "trophy",
						},
						enabled: true,
					},
					{
						title: "Store",
						name: "store",
						icon: {
							default: "cart-outline",
							selected: "cart",
						},
						enabled: true,
					},
					{
						title: "Articles",
						name: "(articles)/articles",
						icon: {
							default: "file-document-multiple-outline",
							selected: "file-document-multiple",
						},
						enabled: false,
					},
					{
						title: "Articles",
						name: "articles",
						icon: {
							default: "file-document-multiple-outline",
							selected: "file-document-multiple",
						},
						enabled: false,
					},
					{
						title: "Challenges",
						name: "challenges",
						icon: {
							default: "arm-flex-outline",
							selected: "arm-flex",
						},
						enabled: false,
					},
					{
						title: "More",
						name: "more",
						icon: {
							default: "menu",
							selected: "microsoft-xbox-controller-menu",
						},
						enabled: true,
					},
					{
						title: "Challenges",
						name: "library",
						icon: {
							default: "arm-flex-outline",
							selected: "arm-flex",
						},
						enabled: false,
					},
				],
			},
		},
		sessionView: null,
		theme: {
			colors: {
				light: {
					primary: "rgb(0, 102, 132)",
					onPrimary: "rgb(255, 255, 255)",
					primaryContainer: "rgb(190, 233, 255)",
					onPrimaryContainer: "rgb(0, 31, 42)",
					secondary: "rgb(0, 104, 116)",
					onSecondary: "rgb(255, 255, 255)",
					secondaryContainer: "rgb(131, 220, 235)",
					onSecondaryContainer: "rgb(0, 31, 36)",
					tertiary: "rgb(93, 91, 125)",
					onTertiary: "rgb(255, 255, 255)",
					tertiaryContainer: "rgb(227, 223, 255)",
					onTertiaryContainer: "rgb(26, 24, 54)",
					error: "rgb(186, 26, 26)",
					onError: "rgb(255, 255, 255)",
					errorContainer: "rgb(255, 218, 214)",
					onErrorContainer: "rgb(65, 0, 2)",
					background: "rgb(251, 252, 254)",
					onBackground: "rgb(25, 28, 30)",
					surface: "rgb(251, 252, 254)",
					onSurface: "rgb(25, 28, 30)",
					surfaceVariant: "rgb(220, 228, 233)",
					onSurfaceVariant: "rgb(64, 72, 76)",
					outline: "rgb(112, 120, 125)",
					outlineVariant: "rgb(192, 200, 205)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(46, 49, 50)",
					inverseOnSurface: "rgb(239, 241, 243)",
					inversePrimary: "rgb(104, 211, 255)",
					elevation: {
						level0: "transparent",
						level1: "rgb(238, 245, 248)",
						level2: "rgb(231, 240, 244)",
						level3: "rgb(223, 236, 241)",
						level4: "rgb(221, 234, 239)",
						level5: "rgb(216, 231, 237)",
					},
					surfaceDisabled: "rgba(25, 28, 30, 0.12)",
					onSurfaceDisabled: "rgba(25, 28, 30, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
				dark: {
					primary: "rgb(104, 211, 255)",
					onPrimary: "rgb(0, 53, 70)",
					primaryContainer: "rgb(0, 77, 100)",
					onPrimaryContainer: "rgb(190, 233, 255)",
					secondary: "rgb(79, 216, 235)",
					onSecondary: "rgb(0, 54, 61)",
					secondaryContainer: "rgb(0, 79, 88)",
					onSecondaryContainer: "rgb(151, 240, 255)",
					tertiary: "rgb(198, 194, 234)",
					onTertiary: "rgb(47, 45, 77)",
					tertiaryContainer: "rgb(69, 67, 100)",
					onTertiaryContainer: "rgb(227, 223, 255)",
					error: "rgb(255, 180, 171)",
					onError: "rgb(105, 0, 5)",
					errorContainer: "rgb(147, 0, 10)",
					onErrorContainer: "rgb(255, 180, 171)",
					background: "rgb(25, 28, 30)",
					onBackground: "rgb(225, 226, 228)",
					surface: "rgb(25, 28, 30)",
					onSurface: "rgb(225, 226, 228)",
					surfaceVariant: "rgb(64, 72, 76)",
					onSurfaceVariant: "rgb(192, 200, 205)",
					outline: "rgb(138, 146, 151)",
					outlineVariant: "rgb(64, 72, 76)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(225, 226, 228)",
					inverseOnSurface: "rgb(46, 49, 50)",
					inversePrimary: "rgb(0, 102, 132)",
					elevation: {
						level0: "transparent",
						level1: "rgb(29, 37, 41)",
						level2: "rgb(31, 43, 48)",
						level3: "rgb(34, 48, 55)",
						level4: "rgb(35, 50, 57)",
						level5: "rgb(36, 54, 62)",
					},
					surfaceDisabled: "rgba(225, 226, 228, 0.12)",
					onSurfaceDisabled: "rgba(225, 226, 228, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
			},
			roundness: 2,
		},
	},
	proethica: {
		tenant: {
			id: "8d3957a4-07a3-497e-85d4-131cbcf3d3b3",
			name: "Proethica",
		},
		supportEmail: "praxis@ets.org",
		companyName: "ETS",
		app: {
			id: "c44943ee-543b-4087-8029-cc0ef158973b",
			name: "PRAXIS PROETHICA",
			trademark: "Proethica",
			font: "opensans",
			purchase: {},
			scoreRanges: [
				{
					rangeArray: [0, 39],
					range: "0-59",
					color: "rgba(212, 84, 84, 1)",
					icon: "emoticon-sad-outline",
				},
				{
					rangeArray: [40, 59],
					range: "60-79",
					color: "rgba(181, 77, 33, 1)",
					icon: "emoticon-neutral-outline",
				},
				{
					rangeArray: [60, 100],
					range: "80-100",
					color: "rgba(82, 167, 141, 1)",
					icon: "emoticon-happy-outline",
				},
			],
			fontSizes: {
				stem: 17,
				answer: 15,
			},
			analytics: {
				mixpanel: {
					id: "fa9c619bbdd5631c565a957a1bc0b1b5",
				},
			},
			logo: {
				stacked: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
				default: {
					light: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
					dark: {
						uri: "https://praxis.ets.org/on/demandware.static/Sites-ETS-Praxis-Site/-/default/dw39d4372d/images/favicons/favicon-32x32.png",
					},
				},
			},
			links: {
				baseUrl: "https://app.proethica.memorang.app",
				privacy: "https://memorang.com/legal/privacy",
				tos: "https://memorang.com/legal/terms",
				ios: "",
				iosLocalised: {
					"en-US": "",
					"ja-JP": "",
					"zh-CN": "",
				},
				android: "",
				androidLocalised: {
					"en-US": "",
					"ja-JP": null,
					"zh-CN": null,
				},
				redeemSupportUrl: "https://www.ets.org/legal/terms.html",
				companyUrl: "https://ets.org",
				contactSupportUrl: "https://ets.custhelp.com/app/forms/praxis",
			},
			keys: {
				revenueCat: {
					ios: "",
					android: "",
				},
				oneSignalAppId: "",
				clerk: {
					publishableKeyProd:
						"pk_live_Y2xlcmsuYXBwLnByb2V0aGljYS5tZW1vcmFuZy5hcHAk",
					publishableKeyDev:
						"pk_test_cnVsaW5nLWJ1enphcmQtOC5jbGVyay5hY2NvdW50cy5kZXYk",
				},
			},
			aiAssistant: {
				title: "Health Mentor",
				alias: "Health Mentor",
				icon: "https://yzshdoomwjkaqrvelrki.supabase.co/storage/v1/object/public/memorang-assets/partners/acme/healthcare.png?t=2024-11-15T05%3A16%3A47.701Z",
				showOriginalQuestion: false,
				initialMessage:
					"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
				initialAiMessage: {
					"en-US":
						"👋 I’m **{{alias}}**. Let’s review this and sharpen your skills.",
					"ja-JP":
						"👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
					"zh-CN":
						"👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**",
				},
			},
			isImageChallengeApp: false,
			landing: {
				title: {
					prefix: "The",
					decoratedText: "official",
					suffix: "AI app for Proethica",
				},
				marketText: {
					prefix: "Start for free",
					suffix: "with a diagnostic",
				},
				valueProps: [
					{
						icon: "book-open-page-variant-outline",
						title: "Official Practice",
						subtitle: "400+ items authored by the official Proethica team",
					},
					{
						icon: "head-snowflake-outline",
						title: "Personalised AI Coach",
						subtitle: "Real-time, AI-powered grading, feedback, and tutoring",
					},
					{
						icon: "web",
						title: "Study Anywhere",
						subtitle:
							"Study on the web or download the iPhone and Android apps",
					},
				],
				landingGraphics:
					"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/toefl-items//login-graphics.png",
			},
			showCountrySelection: false,
			elevenLabs: {
				modelId: "eleven_flash_v2_5",
				voiceId: "nova",
			},
			appAvailabilityRegions: ["MX", "FR", "DE", "JP", "US"],
		},
		groupByCategory: null,
		exam: {
			enabled: true,
		},
		store: {
			enabled: false,
		},
		homeView: {
			showRecommendedChallenge: false,
			showArticles: false,
			showChallengeOfTheWeek: false,
		},
		showStudyPackAsHome: null,
		reportView: {
			practiceTest: {
				reviewEnabled: false,
			},
		},
		onboarding: [
			{
				step: "welcome",
				enabled: true,
				data: [
					{
						icon: "information-outline",
					},
					{
						icon: "shield-account-variant-outline",
					},
					{
						icon: "shield-account-outline",
					},
					{
						icon: "scale-balance",
					},
				],
			},
		],
		navigation: {
			routes: {
				main: [
					{
						title: "Home",
						name: "home",
						icon: {
							default: "home-outline",
							selected: "home",
						},
						enabled: true,
						custom: false,
					},
					{
						title: "Progress",
						name: "progress",
						icon: {
							default: "chart-timeline-variant-shimmer",
							selected: "chart-line-variant",
						},
						enabled: true,
					},
					{
						title: "Study-Pack",
						name: "study-pack",
						icon: {
							default: "chart-timeline-variant-shimmer",
							selected: "chart-line-variant",
						},
						enabled: false,
					},
					{
						title: "Progress",
						name: "podcasts",
						icon: {
							default: "chart-timeline-variant-shimmer",
							selected: "chart-line-variant",
						},
						enabled: false,
					},
					{
						title: "Leaders",
						name: "leaderboard",
						icon: {
							default: "trophy-outline",
							selected: "trophy",
						},
						enabled: true,
					},
					{
						title: "Profile",
						name: "profile",
						icon: {
							default: "account-outline",
							selected: "account",
						},
						enabled: true,
					},
					{
						title: "Store",
						name: "store",
						icon: {
							default: "cart-outline",
							selected: "cart",
						},
						enabled: false,
					},
					{
						title: "More",
						name: "more",
						icon: {
							default: "menu",
							selected: "microsoft-xbox-controller-menu",
						},
						enabled: false,
					},
					{
						title: "Study Guides",
						name: "study-guides",
						icon: {
							default: "note-multiple",
							selected: "note-multiple-outline",
						},
						enabled: false,
					},
					{
						title: "Library",
						name: "articles",
						icon: {
							default: "book-open-page-variant-outline",
							selected: "book-open-page-variant",
						},
						enabled: false,
					},
					{
						title: "Library",
						name: "(articles)/articles",
						icon: {
							default: "book-open-page-variant-outline",
							selected: "book-open-page-variant",
						},
						enabled: false,
					},
					{
						title: "Challenges",
						name: "library",
						icon: {
							default: "arm-flex-outline",
							selected: "arm-flex",
						},
						enabled: false,
					},
				],
			},
		},
		sessionView: null,
		theme: {
			colors: {
				light: {
					primary: "rgb(0, 102, 132)",
					onPrimary: "rgb(255, 255, 255)",
					primaryContainer: "rgb(190, 233, 255)",
					onPrimaryContainer: "rgb(0, 31, 42)",
					secondary: "rgb(0, 104, 116)",
					onSecondary: "rgb(255, 255, 255)",
					secondaryContainer: "rgb(131, 220, 235)",
					onSecondaryContainer: "rgb(0, 31, 36)",
					tertiary: "rgb(93, 91, 125)",
					onTertiary: "rgb(255, 255, 255)",
					tertiaryContainer: "rgb(227, 223, 255)",
					onTertiaryContainer: "rgb(26, 24, 54)",
					error: "rgb(186, 26, 26)",
					onError: "rgb(255, 255, 255)",
					errorContainer: "rgb(255, 218, 214)",
					onErrorContainer: "rgb(65, 0, 2)",
					background: "rgb(251, 252, 254)",
					onBackground: "rgb(25, 28, 30)",
					surface: "rgb(251, 252, 254)",
					onSurface: "rgb(25, 28, 30)",
					surfaceVariant: "rgb(220, 228, 233)",
					onSurfaceVariant: "rgb(64, 72, 76)",
					outline: "rgb(112, 120, 125)",
					outlineVariant: "rgb(192, 200, 205)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(46, 49, 50)",
					inverseOnSurface: "rgb(239, 241, 243)",
					inversePrimary: "rgb(104, 211, 255)",
					elevation: {
						level0: "transparent",
						level1: "rgb(238, 245, 248)",
						level2: "rgb(231, 240, 244)",
						level3: "rgb(223, 236, 241)",
						level4: "rgb(221, 234, 239)",
						level5: "rgb(216, 231, 237)",
					},
					surfaceDisabled: "rgba(25, 28, 30, 0.12)",
					onSurfaceDisabled: "rgba(25, 28, 30, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
				dark: {
					primary: "rgb(104, 211, 255)",
					onPrimary: "rgb(0, 53, 70)",
					primaryContainer: "rgb(0, 77, 100)",
					onPrimaryContainer: "rgb(190, 233, 255)",
					secondary: "rgb(79, 216, 235)",
					onSecondary: "rgb(0, 54, 61)",
					secondaryContainer: "rgb(0, 79, 88)",
					onSecondaryContainer: "rgb(151, 240, 255)",
					tertiary: "rgb(198, 194, 234)",
					onTertiary: "rgb(47, 45, 77)",
					tertiaryContainer: "rgb(69, 67, 100)",
					onTertiaryContainer: "rgb(227, 223, 255)",
					error: "rgb(255, 180, 171)",
					onError: "rgb(105, 0, 5)",
					errorContainer: "rgb(147, 0, 10)",
					onErrorContainer: "rgb(255, 180, 171)",
					background: "rgb(25, 28, 30)",
					onBackground: "rgb(225, 226, 228)",
					surface: "rgb(25, 28, 30)",
					onSurface: "rgb(225, 226, 228)",
					surfaceVariant: "rgb(64, 72, 76)",
					onSurfaceVariant: "rgb(192, 200, 205)",
					outline: "rgb(138, 146, 151)",
					outlineVariant: "rgb(64, 72, 76)",
					shadow: "rgb(0, 0, 0)",
					scrim: "rgb(0, 0, 0)",
					inverseSurface: "rgb(225, 226, 228)",
					inverseOnSurface: "rgb(46, 49, 50)",
					inversePrimary: "rgb(0, 102, 132)",
					elevation: {
						level0: "transparent",
						level1: "rgb(29, 37, 41)",
						level2: "rgb(31, 43, 48)",
						level3: "rgb(34, 48, 55)",
						level4: "rgb(35, 50, 57)",
						level5: "rgb(36, 54, 62)",
					},
					surfaceDisabled: "rgba(225, 226, 228, 0.12)",
					onSurfaceDisabled: "rgba(225, 226, 228, 0.38)",
					backdrop: "rgba(42, 49, 54, 0.4)",
				},
			},
			roundness: 2,
		},
	},
};
